import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import ResourcePageLeftPanel from 'components/ResourcePageLeftPanel';
import AppContainer from 'components/AppContainer';
import { hidePageSidebar } from 'utils/embedded';

const useStyles = makeStyles(theme => ({
  root: {
    background: '#FFFFFF',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  leftPanel: {
    width: 398,
    'box-shadow': '0 2px 24px 10px rgba(0,0,0,0.05)',
    [theme.breakpoints.down('md')]: {
      width: 300,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  rightPanel: {
    width: 'calc(100% - 398px)',
    padding: 56,
    [theme.breakpoints.down('md')]: {
      width: 'calc(100% - 300px)',
      padding: 40,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: 0,
    },
  },
  fullPage: {
    width: '100%',
    paddingTop: 20,
  },
}));

function ResourcePageLayout({
  leftPanelData,
  rightPanel,
  leftPanelBottomNode,
}) {
  const showSidebar = !hidePageSidebar();
  const classes = useStyles();

  if (showSidebar) {
    return (
      <Box component="div" display="flex" className={classes.root}>
        {/* <MobileTaggedTopics data={_get(leftPanelData, 'acceptedTopics')} />
        <MobileActionsPanel data={leftPanelData} /> */}

        <Box component="div" className={classes.leftPanel}>
          <ResourcePageLeftPanel
            data={leftPanelData}
            bottomNode={leftPanelBottomNode}
          />
        </Box>

        <Box component="div" className={classes.rightPanel}>
          {rightPanel()}
        </Box>
      </Box>
    );
  }
  return (
    <AppContainer>
      <Box component="div" className={classes.fullPage}>
        {rightPanel()}
      </Box>
    </AppContainer>
  );
}

ResourcePageLayout.propTypes = {
  leftPanelData: PropTypes.object,
  rightPanel: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

export default ResourcePageLayout;
